(function () {
    'use strict';

    angular
        .module('app')
        .controller('timeLineListController', timeLineListController);

    timeLineListController.$inject = ['$scope', '$http', '$sce'];
    function timeLineListController($scope, $http, $sce) {

        /* jshint validthis:true */
        var vm = this;
        vm.eventViewModel = null;
        //vm.getEventModel = getVideomodel;
        vm.getNextResults = getNextResults;
        vm.convertToTrustedHtml = convertToTrustedHtml;
        vm.init = init;
        vm.totalEvents = null;
        vm.skip = 3;
        vm.disableInfinteScroll = true;
        vm.take = 3;
        vm.pageref = null;

        function getEventData(take, skip) {
            var config = {
                params: {
                    aboutUsPageRef: vm.pageref,
                    take: take,
                    skip: skip
                }
            };
            return $http.get("/api/aboutus/get-events", config, { cache: false });
        }

        function getNextResults(take) {
            if (vm.totalEvents > vm.skip) {
                vm.disableInfinteScroll = true;
                getEventData(take, vm.skip).then(
                    function (result) {
                        vm.eventViewModel.years = vm.eventViewModel.years.concat(result.data.years);
                        vm.skip = vm.eventViewModel.years.length;
                        //vm.totalVideos = result.data.totalCount;
                        vm.disableInfinteScroll = !result.data.showMore;
                    },
                    function(reason) {
                    },
                    function(error) {
                        Console.log(error);
                    }
                );
            } else {
                vm.showMore = false;
            }
        }
        function getEventModel(take, skip) {
            getEventData(take, 0).then(
                    function (result) {
                        console.log(result.data);
                        vm.eventViewModel = result.data;
                        vm.totalEvents = result.data.totalCount;
                        vm.disableInfinteScroll = !result.data.showMore;
                    },
                    function (reason) {
                    },
                    function (error) {
                        Console.log(error);
                    }
                );
        }

        function init(pageref) {
            vm.pageref = pageref;
            getEventModel(3, 0);
        }
        //activate();

        function convertToTrustedHtml(embedCode) {
            return $sce.trustAsHtml(embedCode);
        }
    }
})();




